// AboutPanel — Settings → About: the app's name and its version, pure.
//
// Moved here from the menu's foot (pen "Left menu – detail design" §6). The
// version reads as the full number plus build; a click copies it (the shell
// writes the clipboard), as at the menu's foot.

export { AboutPanel };

import type { ReactNode } from "react";
import { VersionLabel } from "../../VersionLabel/VersionLabel.js";
import { SettingsSection } from "../SettingsSection/SettingsSection.js";

const AboutPanel = ({
    appName,
    version,
    onCopyVersion,
}: {
    readonly appName: string;
    // The full version with its build ("0.6.0 (abc1234)").
    readonly version: string;
    readonly onCopyVersion?: () => void;
}): ReactNode => (
    <SettingsSection title={appName}>
        <div>
            <VersionLabel version={version} onCopy={onCopyVersion} />
        </div>
    </SettingsSection>
);
